/**
 * alertRule模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const alertRule = {
  // 查询报警方式
  alarmWay(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/alarmWay`, param);
  },
  // 查询阈值
  selectMonitorIndexDefault(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/selectMonitorIndexDefault`, params);
  },
  //查询监控指标
  searchMonitorIndex(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/searchMonitorIndex`, params);
  },
  //查询监控指标
  searchDefaultMonitorIndex(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/searchDefaultMonitorIndex`, param);
  },
  //查询监控指标（按监控模块过滤）
  searchDefaultMonitorIndexByModule(monitorModule) {
    let param = new URLSearchParams();
    if (monitorModule !== '' && monitorModule !== null && monitorModule !== undefined) {
      param.append('monitorModule', monitorModule);
    }
    return $http.post(`${global.API_URL}/sme/alertRule/searchDefaultMonitorIndex`, param);
  },
  //查询监控指标
  searchDefaultMonitorIndexByCloudPlatform(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/searchDefaultMonitorIndexByCloudPlatform`, params);
  },
  //查询财务默认监控指标
  searchBillingDefaultMonitorIndex(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/searchBillingDefaultMonitorIndex`, param);
  },
  //查询监控模块
  searchMonitorModule(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/searchMonitorModule`, param);
  },
  searchMonitorModuleV2(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/searchMonitorModuleV2`, param);
  },
  //查询监控模块
  searchMonitorModuleByDefault(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/searchMonitorModuleByDefault`, param);
  },
  //查询监控时间段
  monitorPeriod(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/monitorPeriod`,param);
  },
  //创建报警规则
  createAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/create`, params);
  },
  //报警规则分页
  pageAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/page`, params);
  },
  //报警规则删除
  deleteAlertRule(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/delete`, param);
  },
  //开启或关闭state
  changeStatus(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/changeStatus`, params);
  },
  //编辑报警规则
  updateAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/updateRule`, params);
  },
  //根据ID查询报警规则
  selectAlertRule(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/selectAlertRule`, param);
  },
  //查询报警规则下的资源
  selectInstantiationByAlertRule(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/selectInstantiationByAlertRule`, param);
  },
  //报警规则名称是否重复
  nameRepeatedCheck(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/nameRepeatedCheck`, params);
  },
  // 下载Excel文件
  exportAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/exportAlertRule`, params, {responseType: 'arraybuffer'});
  },
  exportResourceAlertRule(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/exportResourceAlertRule`, params, {responseType: 'arraybuffer'});
  },
  //报警规则一览
  alarmRuleColumn(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/alarmRuleColumn`, params);
  },
  // 查询区间报警指标
  searchIntervalAlarm(params) {
    return $http.post(`${global.API_URL}/sme/alertRule/searchIntervalAlarm`, params);
  },
  //查询报警延迟
  alarmDelay(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRule/alarmDelay`, param);
  }
}

export default alertRule;



// WEBPACK FOOTER //
// ./src/api/alertRule.js